import { all } from 'redux-saga/effects'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { logger } from 'redux-logger'
import { createReduxHistoryContext } from 'redux-first-history'
import userSaga from './user/sagas'
import menuSaga from './menu/sagas'
import settingsSaga from './settings/sagas'
import reducers from './reducers'

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory()
})

const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, routerMiddleware]

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger)
}

const rootReducer = combineReducers({
  router: routerReducer,
  ...reducers
})

const enhancers = compose(applyMiddleware(...middlewares))

const store = createStore(rootReducer, enhancers)
const history = createReduxHistory(store)

function* rootSaga() {
  yield all([userSaga(), menuSaga(), settingsSaga()])
}

sagaMiddleware.run(rootSaga)

export { store, history }
